<span
	*ngIf="icon"
	class="obg-m-verification-code-icon {{ icon.className }}"
	[attr.data-test-id]="icon.testId"
	[attr.test-id]="icon.testId"
></span>
<h3>{{ title }}</h3>
